<template>
    <button class="button-filter"
            v-on="$listeners"><span>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 56.1 60.1">
  <g id="Group_1506" data-name="Group 1506" transform="translate(56.05 0.05) rotate(90)">
    <path id="Path_5230" data-name="Path 5230" d="M7.98,23.08A.235.235,0,0,0,8,23V1A1,1,0,0,0,6,1V23a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84A.235.235,0,0,0,6,37V55a1,1,0,0,0,2,0V37a.235.235,0,0,0-.02-.08,6.987,6.987,0,0,0,0-13.84ZM7,35a5,5,0,1,1,5-5A5,5,0,0,1,7,35Z" fill="#ffffff" stroke="#ffffff" stroke-width="1"/>
    <path id="Path_5231" data-name="Path 5231" d="M30.98,36.08c0-.03.02-.05.02-.08V1a1,1,0,0,0-2,0V36a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84c0,.03-.02.05-.02.08v5a1,1,0,0,0,2,0V50a.235.235,0,0,0-.02-.08,6.987,6.987,0,0,0,0-13.84ZM30,48a5,5,0,1,1,5-5A5,5,0,0,1,30,48Z" fill="#ffffff" stroke="#ffffff" stroke-width="1"/>
    <path id="Path_5232" data-name="Path 5232" d="M60,15a7,7,0,0,0-6.02-6.92A.235.235,0,0,0,54,8V1a1,1,0,0,0-2,0V8a.235.235,0,0,0,.02.08,6.987,6.987,0,0,0,0,13.84c0,.03-.02.05-.02.08V55a1,1,0,0,0,2,0V22a.235.235,0,0,0-.02-.08A7,7,0,0,0,60,15Zm-7,5a5,5,0,1,1,5-5A5,5,0,0,1,53,20Z" fill="#ffffff" stroke="#ffffff" stroke-width="1"/>
  </g>
</svg></span>Dopasuj prezenty<div v-if="totalFilters>0">{{ totalFilters }}</div>
    </button>
</template>

<script>
    export default {
        name: "ButtonFilter",
        props: {
            totalFilters: Number,
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/variables";
    @import "../../../../../scss/mixins/breakpoint";

    button.button-filter {
        margin: 0 0 0 0;
        border: 0 none;
        background-color: #212121;
        color: #ffffff;
        padding: 0;
        font-size: 18px;
        cursor: pointer;
        width: 50%;
        line-height: 75px;
        display: inline-block;

        @include only-mobile-breakpoint() {
            font-size: 13px;
            line-height: 52px;

            > span {
                margin-right: 5px !important;
                svg {
                    height: 13px;
                    width: 13px;
                }
            }
        }

        &:focus {
            outline: 0 !important;
        }

        &:hover {
            background-color: #111111;
        }

        & span {
            margin-right: 20px;
        }
        & div:before {
            content: "wybrane filtry: ";
        }
        & div {
            display: inline-block;
            background-color: #942E00;
            float: right;
            font-size: 14px;
            padding: 0 20px;
            color: white;
        }
    }

    @media (max-width: 720px) {
        button.button-filter div:before {
            content: "";
        }
        button.button-filter div {
            padding: 0 5px;
        }
    }
</style>
